import { useState, useEffect, useMemo, useRef } from "react";
import { useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { HighlightablePolygon, PolygonRendererProvider, colors as resColors } from "../modules/HighlightablePolygonGradient";
import { useSelector } from "react-redux";
import { selectElectricityFiltered } from "../../store/selectors/supervisionSelector";

export const LayerRes = props => {
    const map = useMap();
    const [zoom, setZoom] = useState(map.getZoom());
    const paneRef = useRef(null);
    
    const { drawing } = useSelector((state) => state.helper);
    const { res } = useSelector(selectElectricityFiltered);

    // Оптимизация: слушаем только zoom (bounds не используется)
    useEffect(() => {
        const handleZoomEnd = () => setZoom(map.getZoom());
        map.on('zoomend', handleZoomEnd);
        return () => map.off('zoomend', handleZoomEnd);
    }, [map]);

    // Получаем pane один раз
    useEffect(() => {
        paneRef.current = map.getPane('resPane');
    }, [map]);

    // Мемоизируем создание полигонов (до условного return!)
    const markers = useMemo(() => {
        if (!res) return [];
        
        const result = [];
        
        for (let i = 0; i < res.length; i++) {
            const mark = res[i];
            const coords = mark.coordinates;
            // Привязываем цвет к fid, чтобы он был стабильным
            const colorIdx = mark.fid % resColors.length;
            
            if (coords.length > 1) {
                // Несколько контуров
                for (let j = 0; j < coords.length; j++) {
                    result.push(
                        <HighlightablePolygon 
                            key={`${mark.fid}_${j}`} 
                            positions={coords[j]} 
                            name={mark.name} 
                            colorIndex={colorIdx} 
                        />
                    );
                }
            } else {
                // Один контур
                result.push(
                    <HighlightablePolygon 
                        key={mark.fid} 
                        positions={coords[0]} 
                        name={mark.name} 
                        colorIndex={colorIdx} 
                    />
                );
            }
        }
        
        return result;
    }, [res]);

    // Управляем pointer-events
    useEffect(() => {
        if (paneRef.current) {
            paneRef.current.style.pointerEvents = 
                (!res || zoom > 12 || drawing.state) ? 'none' : 'auto';
        }
    }, [res, zoom, drawing.state]);

    // Если не нужно рисовать — выходим
    if (!res || zoom > 12 || drawing.state) {
        return null;
    }
    
    // Оборачиваем все полигоны в провайдер с общим Canvas renderer
    return (
        <PolygonRendererProvider pane="resPane">
            {markers}
        </PolygonRendererProvider>
    );
}

